import { useEffect, useState } from "react";
import { HomeOfficeRatio } from "../../../../features/Dashboard/dashboard.component";
import { Weekdays } from "../../../Pickers/WeekdayPicker/weekday-picker.component";
import {
  getUserHomeOfficeInfo,
  getUsersAllowedHomeOfficeDays
} from "../../../../utils/axios-requests";

export function useHomeOffice(sub: string) {
  const [homeOfficeRatio, setHomeOfficeRatio] = useState<HomeOfficeRatio>({} as HomeOfficeRatio);
  const [mobileWorkingWeekdays, setMobileWorkingWeekdays] = useState<Weekdays>();

  useEffect(() => {
    getUserHomeOfficeInfo().then(res => setHomeOfficeRatio(res.data[0]));
    getUsersAllowedHomeOfficeDays([sub]).then(r => {
      if (r.data[0] !== undefined && r.data[0]["userId"] !== undefined) {
        delete r.data[0]["userId"];
      }
      setMobileWorkingWeekdays(r.data[0]);
    });
  }, [sub]);

  return { homeOfficeRatio, mobileWorkingWeekdays };
}
